import { render, staticRenderFns } from "./textTem.vue?vue&type=template&id=3baeeb36&scoped=true"
import script from "./textTem.vue?vue&type=script&lang=js"
export * from "./textTem.vue?vue&type=script&lang=js"
import style0 from "./textTem.vue?vue&type=style&index=0&id=3baeeb36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baeeb36",
  null
  
)

export default component.exports